import {API} from "../api/axios";
const END_POINT = '/notices';
const END_POINT_MS = '/notice';
const END_POINT_STAST = '/messages-statistics';
const END_POINT_COUNT = '/total-messages';
const END_POINT_INDICATOR ='/messages-indicators';
const END_POINT_USERS ='/users-list';
const END_NOTICE_CONVERSATION='/notice-conversation' 

class MessageService {
  getConversation(id) {
    return API.get(`${END_NOTICE_CONVERSATION}/${id}`);
}
postConversation(id,params) {
  return API.post(`${END_NOTICE_CONVERSATION}/${id}`,params);
}

  getAll(params) {
    return API.get(END_POINT,params)
  }

  getAllMe(params,notice_status) {
    return API.get(`${END_POINT}/me?user=admin`,params,notice_status)
  }
  nbCount() {
    return API.get(`${END_POINT_INDICATOR}`)
  }
  nbMessage() {
    return API.get(`${END_POINT_COUNT}`)
  }
  getListUsers(id, params) {
    return API.get(`${END_POINT_MS}${END_POINT_USERS}/${id}`,params);
  }
  get(id, params) {
    return API.get(`${END_POINT_MS}/${id}`,params);
}
  getStatsMsg() {
    return API.get(END_POINT_STAST)
  }
  delete(id) {
    return API.delete(`${END_POINT_MS}/${id}`);
  }
  deleteAll(params) {
    return API.delete(`${END_POINT}`,params);
  }
  create(data) {
    return API.post(END_POINT_MS, data);
  }
  vueMsg(id) {
    return API.post(`${END_POINT_MS}/${id}/user`);
}
}

export default new MessageService();